/**
 * Hero Section — Scroll to next section
 */
( function () {
	'use strict';

	function initScrollCta() {
		const btns = document.querySelectorAll( '.js-hero-scroll' );
		if ( ! btns.length ) return;

		btns.forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				const section = btn.closest( '.hero-section' );
				if ( ! section ) return;

				const next = section.nextElementSibling;
				if ( ! next ) return;

				next.scrollIntoView( { behavior: 'smooth', block: 'start' } );
			} );
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initScrollCta );
	} else {
		initScrollCta();
	}
} )();